<template>
    <section-con main="自有硬件稳定有保障" sub="T-BOX第一款专为智能教学打造的AI终端">
        <div class="self-equipment">
            <div class="content">
                <img class="icon-equipment" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/icon-equipment.png">
                <div class="detail-box" v-if="false">
                    <div class="detail-item" v-for="(item, index) in equipmentDetail" :key="index">
                        <img class="detail-icon" :src="item.img">
                        <p class="detail-des">{{item.des}}</p>
                    </div>
                </div>
            </div>
        </div>
    </section-con>
</template>
<script>
import { equipmentDetail } from '@/const'
export default {
    data () {
        return {
            equipmentDetail: equipmentDetail
        }
    }
}
</script>
<style lang="scss" scoped>
.self-equipment{
    padding: 0px 20px;
    .content{
        width: 100%;
        background:#ffffff;
        border-radius:4px;
        border:1px solid #EEEEEE;
        // padding: 30px 20px;
        .icon-equipment{
            width: 100%;
            // height: 104px;
        }
        .detail-box{
            margin-top: 12px;
            display: grid;
            grid-template-columns: 93px 93px 93px;
            grid-template-rows: 93px 93px 93px;
            grid-row-gap: 10px;
            grid-column-gap: 10px;
            .detail-item{
                width: 93px;
                height: 93px;
                background: #F8F9FD;
                border-radius: 4px;
                padding: 24px 0px 14px;
                .detail-icon{
                    width: 36px;
                    height: 36px;
                }
                .detail-des{
                    font-size:10px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#282828;
                    line-height:14px;
                    margin-top: 5px;
                }
            }
        }
    }
}
</style>